module.exports = __webpack_public_path__ + "static/media/NotoSans-ExtraBoldItalic.787c007d.eot";